import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import zhTW from "./locales/zh-TW.json";
import zhCN from "./locales/zh-CN.json";
import en from "./locales/en.json";

// 將 Office 語言代碼映射到 i18n 語言代碼
const mapOfficeLanguageToI18n = (officeLang) => {
  if (!officeLang) return "zh-TW";
  
  // 標準化語言代碼（轉小寫）
  const lang = officeLang.toLowerCase();
  
  // 處理中文變體
  if (lang.startsWith("zh")) {
    // zh-CN, zh-Hans, zh-Hans-CN 等 -> zh-CN
    if (lang.includes("cn") || lang.includes("hans")) {
      return "zh-CN";
    }
    // zh-TW, zh-Hant, zh-Hant-TW 等 -> zh-TW
    if (lang.includes("tw") || lang.includes("hant")) {
      return "zh-TW";
    }
    // 預設繁體中文
    return "zh-TW";
  }
  
  // 處理英文
  if (lang.startsWith("en")) {
    return "en";
  }
  
  // 預設繁體中文
  return "zh-TW";
};

// 偵測 Office 語言的邏輯
const getOfficeLanguage = () => {
  try {
    // Office.context.displayLanguage 回傳格式如 "en-US", "zh-TW", "zh-CN"
    if (typeof Office !== "undefined" && Office.context && Office.context.displayLanguage) {
      const officeLang = Office.context.displayLanguage;
      return mapOfficeLanguageToI18n(officeLang);
    }
  } catch (e) {
    console.warn("無法讀取 Office 語言設定:", e);
  }
  return "zh-TW"; // 預設語言
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      "zh-TW": zhTW,
      "zh-CN": zhCN,
      "en-US": en,
      "en": en
    },
    lng: getOfficeLanguage(), // 初始語言使用 Office 的設定
    fallbackLng: "zh-TW",
    defaultNS: "translation", // 設定預設命名空間
    ns: ["translation"], // 使用的命名空間
    interpolation: {
      escapeValue: false
    }
  });

// 導出函數以便在 Office.onReady 後更新語言
export const updateLanguageFromOffice = () => {
  const detectedLang = getOfficeLanguage();
  if (detectedLang && detectedLang !== i18n.language) {
    i18n.changeLanguage(detectedLang);
    console.log(`語言已切換至: ${detectedLang} (來自 Office: ${Office.context?.displayLanguage})`);
  }
};

export default i18n;